import { render, staticRenderFns } from "./PerGame.vue?vue&type=template&id=3b5d749b&scoped=true&"
import script from "./PerGame.vue?vue&type=script&lang=js&"
export * from "./PerGame.vue?vue&type=script&lang=js&"
import style0 from "./PerGame.vue?vue&type=style&index=0&id=3b5d749b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d749b",
  null
  
)

export default component.exports